import React from "react"
import PropTypes from "prop-types"
import ImmutablePropTypes from "react-immutable-proptypes"
import { connect } from "react-redux"

// redux
import { patchColumnData } from "app/static/frontend/sheets/sheet-action-creators"
import { tagOptionCellConnection } from "app/static/frontend/sheets/selectors/column-selectors"

// components
import CustomTagSelect from "app/static/frontend/selects/components/CustomTagSelect"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export const TagOptionCellComponent = ({
    children,
    clearable,
    columnId,
    cellIsEditable,
    customFieldOptions,
    customFieldOptionsForDisplay,
    editing,
    isEditable,
    menuShouldScrollIntoView,
    multi,
    options,
    rowId,
    sheetId,
    row,
    ...props
}) => {
    const handleChange = (args) => {
        // if this a multi select
        if (multi) {
            const customFields = args.map((customField) => customField.id)
            props.patchColumnData({
                id: sheetId,
                columnId,
                rowId,
                newValue: customFields,
                row,
            })
        } else {
            // this is a little confusing, but id is the new data that was selected
            props.patchColumnData({
                id: sheetId,
                columnId,
                rowId,
                newValue: args.id,
                row,
            })
        }
    }

    return (
        <CellWrapper {...props}>
            {editing && isEditable && cellIsEditable ? (
                <CustomTagSelect
                    allowExpandUp
                    autoload={false || editing}
                    clearable={clearable}
                    menuShouldScrollIntoView={menuShouldScrollIntoView}
                    multi={multi}
                    className={multi ? "inline-choose-many" : ""}
                    onChange={handleChange}
                    options={options.toJS()}
                    value={customFieldOptions}
                />
            ) : (
                customFieldOptionsForDisplay
            )}
        </CellWrapper>
    )
}

TagOptionCellComponent.propTypes = {
    clearable: PropTypes.bool,
    columnId: PropTypes.number.isRequired,
    cellIsEditable: PropTypes.bool,
    customFieldOptions: PropTypes.oneOf([PropTypes.string]).isRequired,
    customFieldOptionsForDisplay: PropTypes.string.isRequired,
    editing: PropTypes.bool,
    isEditable: PropTypes.bool,
    menuShouldScrollIntoView: PropTypes.bool,
    multi: PropTypes.bool,
    options: ImmutablePropTypes.list.isRequired,
    patchColumnData: PropTypes.func.isRequired,
    rowId: PropTypes.number.isRequired,
    sheetId: PropTypes.string.isRequired,
}

TagOptionCellComponent.defaultProps = {
    clearable: false,
    cellIsEditable: true,
    editing: false,
    // keep for backwards compatibility. Eventually should be switched
    // when redoing Sheet.jsx and columnIsEditable
    isEditable: true,
    menuShouldScrollIntoView: false,
    multi: false,
}

export const TagOptionCell: any = connect((state, props) => tagOptionCellConnection(state, props), { patchColumnData })(
    TagOptionCellComponent,
)
